import { HStack, Input, InputGroup } from "@chakra-ui/react";
import { ChangeEvent } from "react";
import i18next from "i18next";
import { NumberAttributeFilter } from "../../../../../map/models/MapFilters";

interface Props {
  setValue: (value: any) => void;
  attributeFilter: NumberAttributeFilter;
}

export const TextFilter: React.FC<Props> = ({ setValue, attributeFilter }) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setValue({ [name]: parseInt(value) });
  };
  return (
    <HStack mb={3} display="flex" alignItems="center">
      <InputGroup startAddon={">="}>
        <Input
          type="number"
          name="min"
          onChange={handleChange}
          value={attributeFilter.min || ""}
          placeholder={i18next.t(`map:filters.min`)}
        />
      </InputGroup>
      <InputGroup startAddon="<=">
        <Input
          type="number"
          name="max"
          onChange={handleChange}
          value={attributeFilter.max || ""}
          placeholder={i18next.t(`map:filters.max`)}
        />
      </InputGroup>
    </HStack>
  );
};
